import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getContainerBoxProps, getListItemBoxProps } from './ListItem.mappers.js';
import { State } from './ListItem.types.js';

var _excluded = ["p", "gap", "state", "type", "href", "title", "subTitle", "leadingAsset", "trailingAsset", "leadingSlot", "contentSlot", "trailingSlot", "role", "borderRadius"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useListItem = function useListItem(props) {
  var p = props.p,
    gap = props.gap,
    state = props.state,
    type = props.type,
    href = props.href,
    title = props.title,
    subTitle = props.subTitle,
    leadingAsset = props.leadingAsset,
    trailingAsset = props.trailingAsset,
    leadingSlot = props.leadingSlot,
    contentSlot = props.contentSlot,
    trailingSlot = props.trailingSlot,
    role = props.role,
    borderRadius = props.borderRadius,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var disabled = state === State.disabled;
  return _objectSpread({
    disabled: disabled,
    p: p,
    role: role,
    containerBoxProps: getContainerBoxProps(disabled, borderRadius),
    listItemBoxProps: getListItemBoxProps(disabled, type, gap, props),
    href: href,
    listItemProps: {
      title: title,
      subTitle: subTitle,
      leadingAsset: leadingAsset,
      trailingAsset: trailingAsset,
      leadingSlot: leadingSlot,
      contentSlot: contentSlot,
      trailingSlot: trailingSlot
    }
  }, remainingProps);
};

export { useListItem };
//# sourceMappingURL=useListItem.js.map
